import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";
import { Label } from "./Label";
import styled, { css } from "styled-components";

const variantPadding = css `padding: ${p => p.theme.spacing.xxs} ${p => p.theme.spacing.xs}`;
const Variant = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.color.darkSlateGray};
    border: 1px ${p => p.theme.color.darkSlateGray} solid;
    border-radius: ${p => p.theme.generic.borderRadius};
    background-color: ${p => p.theme.color.white};
    font-size: ${p => p.theme.font.sizeXs};
    font-weight: ${p => p.theme.font.weightNormal};
    line-height: 13px;
    ${variantPadding};
  }
`;

const ColorBlock = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.primaryColor};
    border-radius: ${p => p.theme.generic.borderRadius};
    display: inline-block;
    height: 9px;
    width: 9px;
  }
`;

class PhoneVariantLabel extends PureComponent {
  render() {
    const { name, primaryColor, secondaryColor } = this.props;

    if (name) {
      return (
        <Variant {...this.props}>
          <ColorBlock
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          />{" "}
          {name}
        </Variant>
      );
    } else {
      return null;
    }
  }
}

PhoneVariantLabel.propTypes = {
  name: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string
};

export default PhoneVariantLabel;
